module.exports = __webpack_public_path__ + "img/66ne.7cdde202.svg";